<template>
  <div ref="datatable" class="datatable">
    <el-table
      :data="tableData"
      :cell-style="{ color: '#fff' }"
      :header-cell-style="{ color: '#fff' }"
      :max-height="tableHeight"
    >
      <el-table-column prop="roundName" label="地市名称" ></el-table-column>
      <el-table-column prop="name" label="考试进度" >
        <template slot-scope="scope">
          {{scope.row.gradedNum | calcPercent(scope.row.totalNum)}}
        </template>
      </el-table-column>
      <el-table-column prop="totalNum" label="总考生"></el-table-column>
      <el-table-column prop="address" label="待考考生">
        <template slot-scope="scope">
          {{scope.row.totalNum - scope.row.gradedNum > 0 ? scope.row.totalNum - scope.row.gradedNum : 0}}
        </template>
      </el-table-column>
      <el-table-column prop="gradedNum" label="已考考生"></el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'data-table',
  props: ['tableData'],
  data() {
    return {
      tableHeight: 300
    }
  },
  mounted() {
    const _this = this
    window.addEventListener('resize', () => {
      if (_this.$refs.datatable) {
        _this.tableHeight = _this.$refs.datatable.getBoundingClientRect().height
      }
    }, false)
    setTimeout(() => {
      if (_this.$refs.datatable) {
        _this.tableHeight = _this.$refs.datatable.getBoundingClientRect().height
      }
    }, 3000)
  }
};
</script>
<style scoped>
.datatable {
  width: 100%;
  height: 100%;
}
.datatable >>> .el-table,
.datatable >>> .el-table__expanded-cell {
  background-color: transparent !important;
}
.datatable >>> .el-table th,
.datatable >>> .el-table tr {
  background-color: transparent !important;
}
/* .datatable >>> .el-table--enable-row-transition .el-table__body td,
.datatable >>> .el-table .cell {
  background-color: transparent !important;
} */
.datatable
  >>> .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background-color: rgba(107, 103, 210, 1);
}
.datatable >>> .el-table--border::after,
.datatable >>> .el-table--group::after,
.datatable >>> .el-table::before {
  background-color: transparent !important;
}
.datatable >>> .el-table th.el-table__cell.is-leaf {
  border-color: transparent !important;
}
/*去除底边框*/
.datatable >>> .el-table td.el-table__cell {
  border-color: transparent !important;
}
.datatable >>> .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: block;
  width: 5px;
  background: transparent;
}

.datatable >>> .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #666;
}

.datatable >>> .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #999;
}
</style>
